// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"ab4c45f0","486":"29c8a38a","632":"01e40165"}[chunkId] + ".chunk.css";
};